import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';

export const Route = createFileRoute('/_app/documents')({
  staticData: { crumb: 'nav.library', crumbTo: '/documents' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'library.access', 'Documents'),
  component: Outlet,
});
